<template>
  <div class="ps-flex ps-items-center">
    <img
      class="ps-w-8 ps-h-8 ps-rounded-sm ps-overflow-hidden ps-block"
      :src="user.__p__avatar"
    />
    <p class="ps-flex-auto ps-pl-2 ps-text-sm">{{ user.__p__value }}</p>
  </div>
</template>

<script>
export default {
  name: 'BaseUser',
  props: {
    userStrategyId: String
  },
  computed: {
    user() {
      if (this.userStrategyId)
        return this.$store.getters.intUserById(this.userStrategyId) || {}
    }
  }
}
</script>
